import { FC } from "react";

import { Box } from "@chakra-ui/react";
import { Formik } from "formik";
import { useTranslation } from "next-i18next";

import useRegistration from "../hooks/useRegistration";
import { REGISTRATION_INITIAL_VALUES } from "../utils/constants";
import { getValidationSchema } from "../utils/validations";
import RegistrationFormFields from "./RegistrationFormFields";

const RegistrationForm: FC = () => {
  const { t } = useTranslation();

  const { handleSubmit, isLoading, errors } = useRegistration();
  return (
    <Box pb="3.25rem" pt="0.5rem">
      <Formik
        validateOnBlur
        validationSchema={getValidationSchema(t)}
        onSubmit={handleSubmit}
        initialValues={REGISTRATION_INITIAL_VALUES}
      >
        {({ setErrors }) => <RegistrationFormFields isLoading={isLoading} setErrors={setErrors} errors={errors} />}
      </Formik>
    </Box>
  );
};

export default RegistrationForm;
